import { z } from 'zod'
import { stringSchema } from './common'

export const ticketCategorySchema = z.object({
  id: stringSchema.min(1),
  price: z.number(),
  // Price-drop fields (BOAT-1739): the reference "was" price and the drop %,
  // already margined/converted like `price`. Both null unless the API has
  // flagged a genuine, Omnibus-compliant drop — never derive them client-side.
  wasPrice: z.number().nullish(),
  discountPercent: z.number().nullish(),
  minQuantity: z.number(),
  maxQuantity: z.number(),
  colour: stringSchema.nullish(),
  title: stringSchema.min(1),
  description: stringSchema.nullish(),
  // Effective value: the category override if set, otherwise the club setting.
  mandatoryHotel: z.boolean().default(false),
  // Key Feature Labels assigned to the category's venue-level TW template in the
  // CMS (BOAT-1904), already resolved to the site locale by the API. Absent on
  // cart/booking payloads, hence the default.
  keyFeatureLabels: z
    .array(z.object({ name: stringSchema.min(1), colour: stringSchema }))
    .default([]),
})

export const performanceSchema = z.object({
  id: stringSchema.min(1),
  externalId: stringSchema.min(1),
  dateTime: stringSchema.min(1),
})

export const availabilitySchema = z.object({
  name: stringSchema.nullish(),
  price: z.number(),
  variationId: stringSchema.nullish(),
  ticketCategory: ticketCategorySchema.nullish(),
  ticketClass: stringSchema.nullish(),
  details: z.record(z.any()).optional()
})
